// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"FamilyBannerShopText_textWrapper__zG_Ib","title":"FamilyBannerShopText_title__m6kuM","cta":"FamilyBannerShopText_cta__dLLqy"};